import PropertyInputV2 from '../v2/components/PropertyInputV2';

// Re-exported from the "v2" folder so clients don't need to be aware
// of the internal file structure and we can refactor at will.

export default PropertyInputV2;